import {
    HorizAlignment, IProfileFilter,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import * as _ from "lodash";
import { WB_ModelPredictorRow } from "../PA.Core/PAdbSchemaRows";
import { ASync } from "../PA.Core/Basic/ASync";

const vUI_Model_Profile_Group_Predictor_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_MODEL_PREDICTOR_ID:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Model Predictor Id',       columnResourceName: 'colId',              alignment: HorizAlignment.Left},  domainOptions: {}},
    MODEL_PREDICTOR_NAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Predictor Name',        columnResourceName: 'colName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODEL_PREDICTOR_ID:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Predictor ID',          columnResourceName: 'colPId',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODEL_PREDICTOR_TYPE:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model Predictor Type',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "PredictorType", useIdAsKey: false}},
  SORT_ORDER_UI:                 {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Sort Order'       ,       columnResourceName: 'colSort',        alignment: HorizAlignment.Right},  domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    INPUT_METHOD:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Input Method',        columnResourceName: 'colInputMethod',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    WB_MODEL_PROFILE_ID:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Model Profile Id',       columnResourceName: 'colPId',              alignment: HorizAlignment.Left},  domainOptions: {}},

};

const vWB_ModelGroupPredictor_KeyFields = {id: 'WB_MODEL_PREDICTOR_ID',
    id_ui: 'MODEL_PREDICTOR_ID',
    name: 'MODEL_PREDICTOR_NAME'

}

class ModelProfileGroupPredictorSearchProfileSearchProvider  implements  ISearchProvider {
    allModelPredictorIds: WB_ModelPredictorRow[] = []
    arrWbModelPredictorIds: number[] = []
    wbModelProfileId: number = -1

    constructor(allModelPredictorIds:WB_ModelPredictorRow[], arrWbModelPredictorIds: number[], wbModelProfileId: number) {
        this.allModelPredictorIds = allModelPredictorIds
        this.arrWbModelPredictorIds = arrWbModelPredictorIds
        this.wbModelProfileId = wbModelProfileId
    }

    get keyFields(){ return vWB_ModelGroupPredictor_KeyFields}

    get searchProviderFields(){
        return vUI_Model_Profile_Group_Predictor_Search_Fields
    }

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return ASync.resolve(_.filter(this.allModelPredictorIds,(aModelPredictor: WB_ModelPredictorRow)=>{
           if(!this.arrWbModelPredictorIds.includes(aModelPredictor.WB_MODEL_PREDICTOR_ID))
            return aModelPredictor.toJSON()
        }))

    }
}

class ModelProfileGroupPredictorSearchProfile implements ISearchProfile{
    profileId= "default"
    profileName= "Search by Id, Name"
    renderOptions= {ui5ResourceId: "ModelProfileGroupPredictorSearchProfileByName"}

    profileFilter: IProfileFilter[] =[
        {profileFilterName: 'Id', searchProviderFieldId: 'MODEL_PREDICTOR_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODEL_PREDICTOR_NAME', renderOptions: {}}
    ] //ISearchFields
    profileDisplayFields= [
        'MODEL_PREDICTOR_ID' , 'MODEL_PREDICTOR_NAME',
    ]

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault= ""   //string;
    profileSorts= [] //ISearchSort[];

    constructor(allModelPredictorIds: WB_ModelPredictorRow[], wbModelPredictorIds: number[],wbModelProfileId: number){
        this.aSearchProvider = new ModelProfileGroupPredictorSearchProfileSearchProvider(allModelPredictorIds,wbModelPredictorIds, wbModelProfileId)
    }

    get profileSearchProvider(){ return this.aSearchProvider }
}


export class ModelProfileGroupPredictorSearchByList implements ISearch  {
/**
 * @param wbModelPredictorIds WB_MODEL_PREDICTOR_ID records that will be excluded from the results
 *    **/
    constructor(allModelPredictorIds: WB_ModelPredictorRow[], wbModelPredictorIds: number[],wbModelProfileId?:number, _options?: any){
        this.searchProfiles = [new ModelProfileGroupPredictorSearchProfile(allModelPredictorIds, wbModelPredictorIds,wbModelProfileId)]
}
    searchName= "Find Model Predictor"
    renderOptions= {ui5ResourceId: "ModelProfileGroupPredictorSearchByList"}
    searchProfileIdDefault= "default"
    searchProfiles: ISearchProfile[]
    autoSearch = true
}



